export default __webpack_public_path__ + "static/media/video.08545df5.mp4";